webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var app_module_1 = __webpack_require__(23);
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },

/***/ 23:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var forms_1 = __webpack_require__(24);
	var http_1 = __webpack_require__(28);
	var app_component_1 = __webpack_require__(29);
	var training_date_component_1 = __webpack_require__(369);
	var map_component_1 = __webpack_require__(370);
	var safe_pipe_1 = __webpack_require__(371);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            declarations: [
	                app_component_1.AppComponent,
	                training_date_component_1.TrainingDateComponent,
	                map_component_1.LocationMap,
	                safe_pipe_1.SafePipe
	            ],
	            imports: [
	                platform_browser_1.BrowserModule,
	                forms_1.FormsModule,
	                http_1.HttpModule,
	                http_1.JsonpModule,
	            ],
	            bootstrap: [app_component_1.AppComponent]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var training_date_1 = __webpack_require__(30);
	var training_date_service_1 = __webpack_require__(31);
	__webpack_require__(357);
	__webpack_require__(366);
	var AppComponent = (function () {
	    function AppComponent(trainingDateService) {
	        this.trainingDateService = trainingDateService;
	        // [
	        //   new TrainingDate(0,14,0, 'Spiceball Park'),
	        //   new TrainingDate(1,18,30, 'The Warriner School')
	        // ];
	        this.events = [
	            new Event('Test Event', new Date(2016, 12, 25))
	        ];
	        this.testTDate = new training_date_1.TrainingDate(1, 1, 1, 'Test');
	        this.loadDates();
	        console.log('training dates:');
	        console.dir(JSON.stringify(this.trainingDates));
	    }
	    AppComponent.prototype.loadDates = function () {
	        var _this = this;
	        this.trainingDateService.getDates()
	            .subscribe(function (dates) { return _this.trainingDates = dates; }, function (err) {
	            console.log(err);
	        });
	    };
	    AppComponent.prototype.ngOnInit = function () {
	        console.log('AppComponent initializing...');
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(368),
	            styles: ["\n        .training-row{\n          margin-bottom: 3em;\n          background-color: #e3e3e3;\n          box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n        }\n    "],
	            providers: [
	                training_date_service_1.TrainingDateService
	            ]
	        }), 
	        __metadata('design:paramtypes', [training_date_service_1.TrainingDateService])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },

/***/ 30:
/***/ function(module, exports) {

	"use strict";
	var dayNames = [
	    'Sunday',
	    'Monday',
	    'Tuesday',
	    'Wednesday',
	    'Thursday',
	    'Friday',
	    'Saturday',
	];
	var TrainingDate = (function () {
	    /**
	     * just a day of a training
	     * @param  {number} weekDay  the day of the week for the training
	     * @param  {number} hour     the hour of the training
	     * @param  {number} minute   the minute of the training
	     * @param  {string} location the location of the training
	     * @return {object}          returns self, in case of piping
	     */
	    function TrainingDate(weekDay, hour, minute, location) {
	        this.weekDay = 0;
	        this.hour = 0;
	        this.minute = 0;
	        this.dayName = '';
	        this.location = '';
	        this.minuteString = '';
	        this.weekDay = weekDay;
	        this.hour = hour;
	        this.minute = minute;
	        this.minuteString = this.minute + (this.minute < 10 ? '0' : '');
	        this.dayName = dayNames[this.weekDay];
	        this.location = location;
	        return this;
	    }
	    return TrainingDate;
	}());
	exports.TrainingDate = TrainingDate;


/***/ },

/***/ 31:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(28);
	var Rx_1 = __webpack_require__(32);
	var TrainingDateService = (function () {
	    function TrainingDateService(http) {
	        this.http = http;
	        this.standardUrl = 'https://s3-eu-west-1.amazonaws.com/www.oradini.com/data.json';
	    }
	    ;
	    TrainingDateService.prototype.getDates = function () {
	        return this.http.get(this.standardUrl)
	            .map(function (res) { return res.json(); })
	            .catch(function (error) { return Rx_1.Observable.throw(error.json().error) || 'server error'; });
	    };
	    TrainingDateService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], TrainingDateService);
	    return TrainingDateService;
	}());
	exports.TrainingDateService = TrainingDateService;


/***/ },

/***/ 357:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 366:
357,

/***/ 368:
/***/ function(module, exports) {

	module.exports = "<div class=\"training-row row\">\n    <h2>Training Times</h2>\n    <div *ngFor=\"let tDate of trainingDates\" class=\"col-xs-12 col-md-12 training-date-col\">\n        <training-date [trainingDate]=\"tDate\"></training-date>\n    </div>\n</div>\n";

/***/ },

/***/ 369:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var training_date_1 = __webpack_require__(30);
	var lightBlue = '#07a4d7';
	var TrainingDateComponent = (function () {
	    function TrainingDateComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', training_date_1.TrainingDate)
	    ], TrainingDateComponent.prototype, "trainingDate", void 0);
	    TrainingDateComponent = __decorate([
	        core_1.Component({
	            selector: 'training-date',
	            template: "\n    <div class=\"training-date-wrapper\">\n      <h3>{{ trainingDate.location }}</h3>\n      <p>{{ trainingDate.dayName }}s at {{ trainingDate.hour }}.{{ trainingDate.minuteString }}</p>\n      <location-map [searchTerm]=\"trainingDate.location\"></location-map>\n    </div>\n  ",
	            styles: ["\n    .training-date-wrapper{\n        padding: 0.5em 1em;\n        background-color: white;\n        margin: 1em;\n        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n    }\n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TrainingDateComponent);
	    return TrainingDateComponent;
	}());
	exports.TrainingDateComponent = TrainingDateComponent;


/***/ },

/***/ 370:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LocationMap = (function () {
	    function LocationMap() {
	        this.searchTerm = 'Spiceball Park Banbury';
	    }
	    LocationMap.prototype.ngOnInit = function () {
	        console.log('map init');
	        this.fullMapUrl = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyDM_exFaOx693tTRzfVzn30Fo77SsrzMwY&q' + this.searchTerm;
	        console.log(this.fullMapUrl);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], LocationMap.prototype, "searchTerm", void 0);
	    LocationMap = __decorate([
	        core_1.Component({
	            selector: 'location-map',
	            template: "\n    <div class=\"location-map-wrapper\">\n        <iframe\n          frameborder=\"0\" style=\"border:0\"\n          [src]=\"'https://www.google.com/maps/embed/v1/place?key=AIzaSyDM_exFaOx693tTRzfVzn30Fo77SsrzMwY&q=' + searchTerm | safe\">\n        </iframe>\n    </div>\n  ",
	            styles: ["\n    iframe{\n        width: 90%;\n        height: 300px;\n\n        margin: 0 auto;\n    }\n    .location-map-wrapper{\n        width: 100%;\n        text-align: center;\n\n        padding: 1em;\n    }\n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocationMap);
	    return LocationMap;
	}());
	exports.LocationMap = LocationMap;


/***/ },

/***/ 371:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var SafePipe = (function () {
	    function SafePipe(sanitizer) {
	        this.sanitizer = sanitizer;
	    }
	    SafePipe.prototype.transform = function (url) {
	        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	    };
	    SafePipe = __decorate([
	        core_1.Pipe({ name: 'safe' }), 
	        __metadata('design:paramtypes', [platform_browser_1.DomSanitizer])
	    ], SafePipe);
	    return SafePipe;
	}());
	exports.SafePipe = SafePipe;


/***/ }

});


/** WEBPACK FOOTER **
 ** app.bd97c60e4580bbc6efa4.js
 **/